const api = {
  url: process.env.API_URL,
  login_web: `https://passport.ijunhai.com/login?redirect_url=http://${
    window.location.host
  }&application_id=8`,
  getSortArr(property) {
    // eslint-disable-next-line func-names
    return function (a, b) {
      const value1 = a[property];
      const value2 = b[property];
      return value1 - value2;
    };
  },
  selectMul(arr1, arr2, type) {
    const arr3 = [];
    for (let i = 0; i < arr2.length; i += 1) {
      for (let j = 0; j < arr1.length; j += 1) {
        if (arr1[j].name === arr2[i]) {
          // eslint-disable-next-line no-param-reassign
          arr1[j].type = type;
          arr3.push(arr1[j]);
        }
      }
    }
    return arr3;
  },
  dateAndSortCompare(property1, property2) {
    // eslint-disable-next-line func-names
    return function (a, b) {
      if (parseInt(a[property1], 10) === parseInt(b[property1], 10)) {
        return Date.parse(b[property2]) - Date.parse(a[property2]);
      }
      return a[property1] - b[property1];
    };
  },
  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  },
};
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js